module.exports = require("qtip");